import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

// ```
// {
//   "name": "MARKETING_CAMPAIGN",
// "template_name": "rsvp_agents",
// "recipients": [
//     {"phone": "+233546803183"},
//     {"phone": "+233540539205"},
//     {"phone": "+33753879936"}
// ],
// "params": true,
// "components": [
//     {
//         "type": "body",
//         "parameters": [
//             {"type": "text", "parameter_name": "first_name", "text": "Gibril"}
//         ]
//     },
//     {
//         "type": "body",
//         "parameters": [
//             {"type": "text", "parameter_name": "first_name", "text": "Joseph"}
//         ]
//     },
//     {
//         "type": "body",
//         "parameters": [
//             {"type": "text", "parameter_name": "first_name", "text": "Elvis"}
//         ]
//     }
    
// ]
// }
// ```
type MutationPayload = {
  name: string;
  template_name: string;
  recipients: {phone: string}[];
  params: boolean;
  components: any[];
}
type MutationPayloadToContactsPayload = {
  template_name?: string;
  /** Free text instead of a template; only with from_number "ultramsg". */
  body?: string;
  /** Marketing campaign (play) this broadcast counts towards. */
  play_id?: number;
  campaign: string;
  description: string;
  params: string[];
  tags: string[];
  from_number: string;
  language_code: string;
}

// type WithMediaPayload = {
//   recipients: string[];
//   message: string;
//   files: File[]
// }
type WithMediaPayload =  FormData



type WithMediaTemplatesPayload = FormData
// type WithMediaTemplatesPayload = {
//   message: string;
//   recipients: string[];
//   template: string;
//   name: string;
//   files: File[]
// }

type MutationResponse = {
  timestamp: string,
  statusCode: number,
  status: number,
  message: string,
  data: any
};

export const useBroadcastMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred during WhatsApp broadcast',
    endpoint: '/api/admin/whatsapp/broadcasts',
    method: 'POST',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};
export const useDeleteBroadcastMutation = () => {
  const mutationFn = useGetMutationFn<{id: string}, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred during WhatsApp broadcast',
    endpoint: ({id}) => `/api/admin/whatsapp/broadcast/${id}`,
    method: 'DELETE',
  });

  return useMutation<MutationResponse, Error, {id: string}>({ mutationFn });
};

export const useBroadcastToContactsMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayloadToContactsPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred during WhatsApp broadcast',
    endpoint: '/api/admin/whatsapp/broadcasts/contacts',
    method: 'POST',
  });

  return useMutation<MutationResponse, Error, MutationPayloadToContactsPayload>({ mutationFn });
};

export const useBroadcastWithMediaMutation = () => {
  const mutationFn = useGetMutationFn<WithMediaPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred during WhatsApp broadcast',
    endpoint: '/api/admin/whatsapp/broadcast-with-media',
    method: 'POST',
  });

  return useMutation<MutationResponse, Error, WithMediaPayload>({ mutationFn });
};

export const useBroadcastWithMediaTemplateMutation = () => {
  const mutationFn = useGetMutationFn<WithMediaTemplatesPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred during WhatsApp broadcast',
    endpoint: '/api/admin/whatsapp/broadcast-with-media-template',
    method: 'POST',
  });

  return useMutation<MutationResponse, Error, WithMediaTemplatesPayload>({ mutationFn });
};